export const SUBSTITUTION_FLOW_API_PATH = Object.freeze({
  // request as PUT, not GET
  READ_ITEMS_REPLACEMENT:
    'api/rs-aliados-gateway/orders/partner/status/orders/search',

  // request as POST
  CREATE_SUBSTITUTE_SINGLE_ITEM:
    'api/rs-aliados-gateway/orders/partner/status/orders/management/substitution/historical',

  // request as POST
  CREATE_SUBSTITUTE_MULTIPLE_ITEMS:
    'api/rs-aliados-gateway/orders/partner/status/orders/management/substitutions',

  // request as POST
  UPDATE_CANCEL_ORDER:
    'api/rs-aliados-gateway/orders/partner/status/orders/management/:orderId/stockout-cancellation',
} as const);
